import { filter, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { MinLotActionTypes, LoadMinLot, LoadMinLotComplete } from '../actions/min-lot.actions';
import { StdLotSizeService } from '@cemex-core/cmx-api';

@Injectable()
export class MinLotEffects {
  minLotSize$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(MinLotActionTypes.LOAD_MIN_LOT),
      mergeMap((action: LoadMinLot) => {
        const payloadProductId = action.payload.productId;
        return this.stdLotSizeService.getProductMinLotSize(action.payload.request).pipe(
          filter((response: any) => !!response.capacities[0]),
          map((response: any) => {
            return new LoadMinLotComplete({ [payloadProductId]: response.capacities[0] });
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private stdLotSizeService: StdLotSizeService,
  ) {}
}
